import { render, staticRenderFns } from "./ResetPasswordLoader.vue?vue&type=template&id=680dd760"
import script from "./ResetPasswordLoader.vue?vue&type=script&lang=js"
export * from "./ResetPasswordLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports